import React from 'react'

import { Sidebar, SidebarLabel, TableSelect } from './style'
import { useDatabaseSidebar } from './useDatabaseSidebar'

const DatabaseSidebar = () => {
    const { selectedTable, tables, setSelectedTable } = useDatabaseSidebar()

    return (
        <Sidebar>
            <SidebarLabel>Таблицы</SidebarLabel>
            <TableSelect
                value={selectedTable}
                onChange={(event) => setSelectedTable(event.target.value)}
            >
                {tables.map((tableName) => (
                    <option key={tableName} value={tableName}>
                        {tableName}
                    </option>
                ))}
            </TableSelect>
        </Sidebar>
    )
}

export default DatabaseSidebar
